import React, { ReactNode } from 'react'
import { Formik, Form, Field, FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

export const GridFilterForm = <T extends {}>({
    children,
    titleKey,
    searchButtonLabelKey,
    onSubmit,
    initialValues,
}: {
    children: ((formikProps: FormikProps<T>) => ReactNode) | ReactNode
    titleKey: string
    searchButtonLabelKey?: string | null;
    onSubmit: (values: T) => void
    initialValues: T,
}) => {
    const { t } = useTranslation()
    return (
        <Formik onSubmit={onSubmit} initialValues={initialValues}>
            {formikProps => <Form className="search-form simple-search">
                <h2 className="search__title">{t(titleKey)}</h2>

                <div className="search__content">
                    {children instanceof Function ? children(formikProps) : children}
                    {searchButtonLabelKey && <button type="submit" className="button button--blue search__button">
                        {t(searchButtonLabelKey)}
                        <span className="icon icon__search mod-margin-left-4"></span>
                    </button>}
                </div>
            </Form>
            }
        </Formik>
    )
}

export const GridFilterInput = ({ name, placeholderKey }: { name: string; placeholderKey: string }) => {
    const { t } = useTranslation()

    return <Field type="text" name={name} placeholder={t(placeholderKey)} className="search__input search__item" />
}
